<script setup lang="ts">
import STWalletBalance from '../wallet/STWalletBalance.vue'
import STPrintVoucherHeaderItem from '../voucher/STPrintVoucherHeaderItem.vue'
</script>

<template>
  <div class="st-header-right-controls">
    <STPrintVoucherHeaderItem />
    <STWalletBalance />
  </div>
</template>

<style lang="scss" scoped>
.st-header-right-controls {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(--nxgds-alias-spacing-xs);
  flex-shrink: 0;
}
</style>
